export default __webpack_public_path__ + "static/media/desc-main-banner.57a5c45b.svg";